import BaseStore from '@src/utils/store/base-store';
import DropDownMenuStore from './dropDownMenu/store';
import { observable, computed, action } from 'mobx';
import SelectStore from '@src/business-components/common-language-select/store';
import FollowUsStore from '@src/business-components/common-follow-us/store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import { jumpPage } from '@src/utils/common-util';
import debounce from 'lodash.debounce';
import { $$tracker } from '@src/tracker';

const lang = getLanguageByPath();
const pageLocalesData = getPageLocalesData();
const navListLocales = pageLocalesData.topBar.navList;
class NaviBarStore extends BaseStore {
  selectStore = new SelectStore();
  /**
   * 关注我的store
   * @type {FollowUsStore}
   */
  followUsStore = new FollowUsStore();

  //官网链接
  @computed
  get officialLink() {
    return `https://mechabreak.seasungames.com/index/${lang}/`;
  }
  @observable isSticky = false;

  dropDownMenuStore = new DropDownMenuStore();

  @observable currentIndex = 0;

  @observable
  navList = [
    {
      id: '1',
      title: navListLocales[0].name,
      url: 'index',
      tracker: $$tracker.clickMainNaviBarHome
    },
    {
      id: '2',
      title: navListLocales[1].name,
      url: 'wordView',
      tracker: $$tracker.clickMainNaviBarTheWorld
    },
    {
      title: navListLocales[2].name,
      id: '3',
      url: 'chronicle',
      tracker: $$tracker.clickMainNaviBarTimeLine
    }
  ];
  @action
  handleScroll = debounce(() => {
    // 直接赋值为防抖函数，无需构造函数绑定this
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const newIsSticky = scrollTop >= 100;
    if (this.isSticky !== newIsSticky) {
      this.isSticky = newIsSticky;
    }
  }, 50); // 50ms 防抖延迟，可根据需求调整
  clickMenu = (index, item) => {
    let info = { ...item };
    info.tracker?.();
    this.toRouter(info.url);
  };

  // 跳转路由-方法有问题接入建站后要特殊处理-跳转其他路由
  toRouter(path) {
    // if (!IS_DEV_ENV) {
    //   const url = `${path}.html`;
    //   jumpPage(url, '#/');
    // } else {
      path === 'index' ? this?.redirect('/') : this.redirect(`/${path}`);
    // }
    this.menuState = false;
  }
  use() {
    super.use();
    // 添加滚动监听（使用 passive 优化性能）
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }
}

export default NaviBarStore;
